import React from 'react';
import {
  useLinks,
  usePostMessageContext,
  useConfig
} from '@providers';

export const TermsLink = () => {
  const links = useLinks();
  const { postMessage } = usePostMessageContext();
  const { phrases } = useConfig();
  const text = phrases['shared.termsAndConditionsLink'];

  const onClick = () => postMessage('seeTermsAndConditions', {
    ctaType: 'disclaimer-header-terms',
  });

  return (
    <a href={links.terms} target='_blank' rel='noreferrer' onClick={onClick}>
      {text}
    </a>
  );
};